import { DateTime } from 'luxon';

export const onDateChange = (setStartdate, setEnddate) => value => {
  setStartdate(
    value?.[1] == null ? (value?.[0] as DateTime).startOf('day') : value?.[0],
  );
  const endValue = value?.[1] || value?.[0];
  setEnddate(endValue.endOf('day'));
};

export const getPreviousPeriod = (
  previousStart: DateTime,
  previousEnd: DateTime,
): [DateTime, DateTime] => {
  // previousStart and previousEnd are start of day and end of day, respectively.
  // In order to get an even diff without fractional days, we have to shift previousEnd
  // a little bit
  let diff = previousEnd
    .plus({ days: 1 })
    .startOf('day')
    .diff(previousStart, ['years', 'quarters', 'months', 'weeks', 'days']);

  return [
    previousStart.minus(diff),
    previousStart.minus({ days: 1 }).endOf('day'),
  ];
};
